import { render, staticRenderFns } from "./itemUserInfo.vue?vue&type=template&id=806c7204&scoped=true&"
import script from "./itemUserInfo.vue?vue&type=script&lang=js&"
export * from "./itemUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./itemUserInfo.vue?vue&type=style&index=0&id=806c7204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806c7204",
  null
  
)

export default component.exports